import axios from 'axios';

import { HOST_API } from 'src/config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API });

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'No existe conexión con el servidor')
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
  auth: {
    me: '/api/v1/session/recoverySession',
    login: '/api/v1/session/login',
    register: '/users/users',
    forgotPassword: '/api/v1/session/resetPassword',
    verificarToken: (token) => `/api/v1/session/check-token-reset/${token}`,
    changePassword: '/api/v1/session/change-password',
    catalogs: '/api/v1/administration/users/public/catalogs',
    logout: '/api/v1/session/logout',
  },
  user: {
    list: '/api/v1/administration/users',
    create: '/api/v1/administration/users',
    update: '/api/v1/administration/users',
    delete: '/api/v1/administration/users',
    changePassword: '/api/v1/administration/users',
    affiliatedBranches: '/api/v1/administration/users/affiliatedBranches',
  },
  branches: {
    list: '/api/v1/maintenance/branches/',
    listByCompany: '/api/v1/maintenance/branches/companie',
    update: '/api/v1/maintenance/branches/',
    create: '/api/v1/maintenance/branches/',
    delete: '/api/v1/maintenance/branches/',
  },
  companies: {
    list: '/api/v1/maintenance/companies/',
    update: '/api/v1/maintenance/companies/',
    create: '/api/v1/maintenance/companies/',
    listSelects: '/api/v1/maintenance/companies/selects',
    delete: '/api/v1/maintenance/companies/',
  },
  rol: {
    list: '/api/v1/administration/roles',
    create: '/api/v1/administration/roles',
    update: '/api/v1/administration/roles',
    delete: '/api/v1/administration/roles',
  },
  relationRolService: {
    list: '/api/v1/administration/rolServices',
    create: '/api/v1/administration/rolServices/dinamicAccordion',
  },
  generalData: {
    getGeneralData: '/api/v1/generalData',
  },
  dashboards: {
    smartSensing: {
      kpiAgeGender: '/api/v1/dashboards/smartSensing/kpis',
      graphVisitorAgeGender: '/api/v1/dashboards/smartSensing/graph-visitors-age-gender',
      kpiVisitas: '/api/v1/dashboards/smartSensing/kpis-visitors',
      fluencyDaily: 'api/v1/dashboards/smartSensing/fluency-daily',
      topAreaDevices: 'api/v1/dashboards/smartSensing/top-area-devices',
      lastSync: 'api/v1/dashboards/smartSensing/last-sync',
      filters: 'api/v1/dashboards/smartSensing/filters',
      permanenciaZonas: 'api/v1/dashboards/smartSensing/permanencia-zonas',
    },
    visitantes: {
      kpiAgeGender: '/api/v1/dashboards/visitantes/kpis',
      graphVisitorAgeGender: '/api/v1/dashboards/visitantes/graph-visitors-age-gender',
      kpiVisitas: '/api/v1/dashboards/visitantes/kpis-visitors',
      fluencyDaily: '/api/v1/dashboards/visitantes/fluency-daily',
      topAreaDevices: '/api/v1/dashboards/visitantes/top-area-devices',
      lastSync: '/api/v1/dashboards/visitantes/last-sync',
      permanenciaZonas: '/api/v1/dashboards/visitantes/permanencia-zonas',
    },
    visitas: {
      kpiAgeGender: '/api/v1/dashboards/visitas/kpis',
      graphVisitorAgeGender: '/api/v1/dashboards/visitas/graph-visitors-age-gender',
      kpiVisitas: '/api/v1/dashboards/visitas/kpis-visitors',
      fluencyDaily: '/api/v1/dashboards/visitas/fluency-daily',
      topAreaDevices: '/api/v1/dashboards/visitas/top-area-devices',
      lastSync: '/api/v1/dashboards/visitas/last-sync',
      permanenciaZonas: '/api/v1/dashboards/visitas/permanencia-zonas',
    },
  },
  device: {
    listByBranch: '/api/v1/maintenance/branches/devices',
    list: '/api/v1/administration/devices',
    create: '/api/v1/administration/devices',
    update: '/api/v1/administration/devices',
    delete: '/api/v1/administration/devices',
  },
  advertising: {
    list: '/api/v1/maintenance/advertising/',
    create: '/api/v1/maintenance/advertising/',
    update: '/api/v1/maintenance/advertising/',
    delete: '/api/v1/maintenance/advertising/',
    images: '/api/v1/maintenance/advertising/images',
    deleteImage: '/api/v1/maintenance/advertising/image',
  },
  scheduler: {
    status: '/api/v1/process/scheduler/status',
    start: '/api/v1/process/scheduler/start',
    stop: '/api/v1/process/scheduler/stop',
    run: '/api/v1/process/scheduler/run',
    retryEmails: '/api/v1/process/scheduler/retry-email',
    runBranch: '/api/v1/process/scheduler/run-branch',
  },
  sensorsMonitor: {
    status: '/api/v1/process/sensorsMonitor/status',
  },
};
